import React from "react";

function Button(props) {
  return (
    <button
      onClick={props.onClickHandler}
      type={props.type}
      className={`text-xs md:text-base py-2 outline-none px-8 rounded hover:scale-95 active:scale-100  delay-100 ${props.btnStyle}`}
    >
      {props.btnName}
    </button>
  );
}

export default Button;
